import * as yup from 'yup'

export class CompanyTransporterInformationDto {
  transporterSCAC?: string = undefined
  dotNumber?: string = undefined
}

export const companyTransporterInformationValidationSchema = yup.object({
  transporterSCAC: yup.string().max(25, 'SCAC cannot be more than 25 characters.').required('SCAC is required.'),
  dotNumber: yup.string().max(25, 'DOT Number cannot be more than 25 characters.').required('DOT Number is required.')
})
